import { readUrlLocale } from 'i18n/urlLocale';

// On a locale-prefixed page (/ja/...), same-site AJAX names the page's locale
// in X-Page-Locale, so endpoints (which stay unprefixed) answer in it
// (docs/i18n.md, "Locale-prefixed URLs"). Controller_Factory reads the header.
const HEADER = 'X-Page-Locale';

// Headers for a same-site fetch() from this page: the locale on a prefixed
// page, nothing otherwise.
export function pageLocaleHeaders(rootDocument = typeof document === 'undefined' ? null : document) {
	const { locale } = readUrlLocale(rootDocument);
	return locale ? { [HEADER]: locale } : {};
}

// Every same-site jQuery request ($.ajax, and Request built on it) carries the
// header. jQuery can't remove a prefilter, so this binds once per page load.
export function bindLocaleRequests(jquery, rootDocument) {
	const { locale } = readUrlLocale(rootDocument);
	if(!locale) {
		return;
	}
	jquery.ajaxPrefilter((options, originalOptions, xhr) => {
		if(!options.crossDomain) {
			xhr.setRequestHeader(HEADER, locale);
		}
	});
}
